var React = require(150)
var r = require(2)
var Html = require(4)

module.exports = React.createClass({
  render: function () {
    var props = this.props

    return r(Html, {
      title: props.name + " - " + props.pitchPhrase,
      description: props.description,
      author: "Holodex",
      favicon: false,
      javascripts: ['js/index.js'],
      stylesheets: ['css/index.css', 'css/fonts.css']
    }, props.children)
  }
})
